import clientLogger from '@/plugins/logger/core'

const cacheKeyFinance = (checkoutId) => `finance_${checkoutId}`

export const getCachedFinanceData = (window, checkoutId) => {
  try {
    return JSON.parse(
      window?.storage?.getItem(cacheKeyFinance(checkoutId)) ??
        JSON.stringify({
          submittedPaymentOptionsGeneration: false,
          selectedFinanceInstalment: 0,
        })
    )
  } catch (err) {
    console.error(err)

    return {}
  }
}

export const cacheFinanceData = (
  window,
  checkoutId,
  selectedFinanceInstalment
) => {
  window?.storage?.setItem(
    cacheKeyFinance(checkoutId),
    JSON.stringify({
      submittedPaymentOptionsGeneration: true,
      selectedFinanceInstalment,
    })
  )
}

export const novaIsInProgress = (window, checkoutId) => {
  try {
    const { submittedPaymentOptionsGeneration = false } = getCachedFinanceData(
      window,
      checkoutId
    )

    return submittedPaymentOptionsGeneration
  } catch (err) {
    clientLogger.warn(
      'failed to identify if nova is in progress. defaulting to false'
    )

    return false
  }
}

export const getDownpayment = (checkoutData) => ({
  amount: checkoutData?.loanSummary?.downpayment?.amount ?? 0,
  currency: checkoutData?.loanSummary?.downpayment?.currency ?? '',
})
